@if (isHeader) {
  <div class="headerToolTip">
    <h2>Mätningsomfattning</h2>
    <div class="sortimentsgrupp">
      <span>Massaved</span>
      <ul>
        <li>
          <b>MO=0</b> Bedöming av Prima/Sekunda och trädslagsfördelning
        </li>
        <li>
          <b>MO=1</b> Bedöming av Prima/Sekunda ingen trädslagsfördelning
        </li>
        <li>
          <b>MO=2</b> Ingen bedöming av Prima/Sekunda men trädslagsfördelning
        </li>
        <li>
          <b>MO=4</b> Ingen bedöming av Prima/Sekunda eller trädslagsfördelning
        </li>
        <li>
          <b>MO=5</b> Travmätning innan Prima/Sekunda dvs. med vrak- och rötbedömning (Exempel viss import)
        </li>
      </ul>
      <i>Gäller för sortiment (SS) 10-19, 90-98 och Mätmetod = Travmätning</i>
    </div>
    <div class="sortimentsgrupp">
      <span>Bränsleved</span>
      <ul>
        <li>
          <b>MO=0</b> Kvalitetklassning JA, trädslagsfördelning NEJ
        </li>
        <li>
          <b>MO=2</b> Kvalitetklassning NEJ, trädslagsfördelning JA
        </li>
        <li>
          <b>MO=3</b> Kvalitetklassning JA, trädslagsfördelning JA
        </li>
        <li>
          <b>MO=4</b> Kvalitetklassning NEJ, trädslagsfördelning NEJ (enbart bruttovolym)
        </li>
        <li>
          <b>MO=5</b> Bestämning av vrakandel, ingen trädslagsfördelning
        </li>
      </ul>
      <i>Gäller för sortiment (SS) 50</i>
    </div>
  </div>
}

@if (!isHeader) {
  <div class="cell"></div>
}